<div id="energymetermap" style="height: 450px; width: 100%;"></div>